var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0192871,
    y: 0.565979,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.49646,
    y: -0.956802,
    width: 72.2398,
    height: 74.2398,
    fill: "#42DA9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7363,
    y: -0.956802,
    width: 72.2398,
    height: 74.2398,
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.49646,
    y: 73.283,
    width: 72.2398,
    height: 74.2398,
    fill: "#FF6299"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7363,
    y: 73.283,
    width: 72.2398,
    height: 74.2398,
    fill: "#BB95FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7784 105.353C46.9419 105.353 39.7784 98.1897 39.7784 89.3531L39.7784 73.2829L72.7365 73.2829L72.7365 105.353L55.7784 105.353Z",
    fill: "#42DA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7784 73.2829L39.7784 57.2128C39.7784 48.3762 46.9419 41.2128 55.7784 41.2128L72.7365 41.2128L72.7365 73.2829L39.7784 73.2829Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7365 105.353L72.7365 73.2829L105.695 73.283L105.695 89.3532C105.695 98.1897 98.5311 105.353 89.6946 105.353L72.7365 105.353Z",
    fill: "#FF6299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7365 73.2829L72.7365 41.2128L89.6946 41.2128C98.5311 41.2128 105.695 48.3762 105.695 57.2128L105.695 73.283L72.7365 73.2829Z",
    fill: "#BB95FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.406 98.3357C104.244 91.6355 108.486 82.297 108.486 71.9677C108.486 51.5799 91.9584 35.0524 71.5707 35.0524C51.1829 35.0524 34.6554 51.5799 34.6554 71.9677C34.6554 92.3554 51.1829 108.883 71.5707 108.883C81.6291 108.883 90.7479 104.86 97.406 98.3357ZM97.406 98.3357L114.018 114.948",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_187"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0192871,
    y: 0.565979,
    width: 145.434,
    height: 145.434,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorzLogo);
export default __webpack_public_path__ + "static/media/colorz_logo.8338a05fd5f04c12de00c1bf34146264.svg";
export { ForwardRef as ReactComponent };